import { render } from "./MiStepper.vue?vue&type=template&id=1854e9c8&scoped=true"
import script from "./MiStepper.vue?vue&type=script&lang=js"
export * from "./MiStepper.vue?vue&type=script&lang=js"

import "./MiStepper.vue?vue&type=style&index=0&id=1854e9c8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1854e9c8"]])

export default __exports__
import QStepper from 'quasar/src/components/stepper/QStepper.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QStepper,QIcon});
